import React from 'react';
import { createStyles } from 'utils/createStyle';

import { ReactComponent as WarningIcon } from '../../../media/images/warning-sign.svg';

const styles = createStyles({
    warningIcon: [
        {
            minWidth: '1.25rem',
        },
    ],
    warningBannerContainer: [
        'flex items-center gap-4',
        {
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: '#B5470840',
            background: '#FFFAEB',
            color: '#B54708',
            fontSize: 14,
            fontWeight: 600,
        },
    ],
});

export const WarningBanner = () => (
    <div className={`${styles.warningBannerContainer} mt-8 gap-4 p-3 pl-5 w-full`}>
        <WarningIcon className={styles.warningIcon} />
        <span>For this brand, both gift card and online earnings cannot be combined.</span>
    </div>
);
